import * as React from 'react'
import { pageContext } from '../../../../types'
import Pagination from '~/components/molecules/Pagination'
import { Container } from '~/components/layout/Container'
import NewsCard from '~/components/molecules/NewsCard'
import * as styles from './styles'
import { useAllMicrocmsNews } from '~/hooks/useAllMicrocmsNews'
import { SmallArticleCard } from '~/components/domain/times/SmallArticleCard'
import { Link } from 'gatsby'
import { useOnsenTimesKeywords } from '~/hooks/useOnsenTimesKeywords'
import Tag from '~/components/atoms/Tag'
import { Header } from '~/components/domain/times/Header'
import { summarize } from '~/utils/seo'
import { ignoreTags } from '~/constant'

type Props = {
    data: GatsbyTypes.BlogListQuery
    pageContext: pageContext
    pathName: string
    tagName?: string
};

export const TimesPage = ({ data, pageContext, pathName, tagName }: Props) => {
    const articles = data?.allMicrocmsNews?.edges ?? []
    const latestNews = useAllMicrocmsNews(3)
    const keywords = useOnsenTimesKeywords(20)

    return (
        <Container>
            <section css={styles.header}>
                <Header path={pathName}/>
            </section>
            {!ignoreTags.includes(tagName) && tagName && (
                <h2 css={styles.tagName}>“{tagName}”</h2>
            )}
            <div css={styles.pageGrid}>
                <div>
                    <ul css={styles.newsList}>
                        {articles.map(({ node }) => (
                            <NewsCard
                                css={styles.newsItem}
                                key={node.newsId}
                                title={node.title}
                                description={summarize(node.contents, 60)}
                                thumbnail={node.thumbnail.url}
                                postDate={node.postDate}
                                publishedAt={node.publishedAt}
                                newsId={node.newsId}
                            />
                        ))}
                    </ul>
                    <Pagination
                        pathName={pathName}
                        currentPageNumber={pageContext.humanPageNumber}
                        numberOfPages={pageContext.numberOfPages}
                        nextPagePath={pageContext.nextPagePath}
                        previousPagePath={pageContext.previousPagePath}
                        css={styles.pagination}
                    />
                </div>
                <div>
                    <div css={styles.popularKeywords}>
                        <h3 css={styles.sectionTitle}>人気のキーワード</h3>
                        <ul css={styles.popularTagList}>
                            {keywords.map(({ node }) => (
                                <li key={node.keywordsId} css={styles.popularNewsItem}>
                                    <Link to={`/times/${node.keywordsId}/`}>
                                        <Tag css={node.title === tagName && styles.activeTag}>{node.title}</Tag>
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div css={styles.latestNews}>
                        <h3 css={styles.sectionTitle}>全ての新着記事</h3>
                        <ul css={styles.latestNewsList}>
                            {latestNews.map(({ node }) => (
                                <li key={node.newsId} css={styles.latestNewsItem}>
                                    <Link to={`/times/${node.newsId}`}>
                                        <SmallArticleCard
                                            title={node.title}
                                            thumbnail={node.thumbnail.url}
                                            publishedAt={node.publishedAt}
                                            category={node.category[0] ?? ''}
                                        />
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </Container>
    )
}